import React from 'react';
import teamimg1 from '../../Assest/images/customer-1.png'
import teamimg2 from '../../Assest/images/customer-2.png'
import teamimg3 from '../../Assest/images/customer-3.png'


const OurTeam = () => {
    return (
        <div className="overflow-x-auto w-full">
            <table className="table w-full">
                {/* head */}
                <thead>
                    <tr>
                      
                        <th>Name</th>
                        <th>Job</th>
                        <th>Contact</th>
                        
                    </tr>
                </thead>
                <tbody>
                    {/* row 1 */}
                    <tr>
                        
                        <td>
                            <div className="flex items-center space-x-3">
                                <div className="avatar">
                                    <div className="mask mask-squircle w-12 h-12">
                                        <img src={teamimg1} alt="team-img" />
                                    </div>
                                </div>
                                <div>
                                    <div className="font-bold">Hart Hagerty</div>
                                    <div className="text-sm opacity-50">United States</div>
                                </div>
                            </div>
                        </td>
                        <td>
                            Zemlak, Daniel and Leannon
                            <br />
                            <span className="badge badge-ghost badge-sm">Desktop Support Technician</span>
                        </td>
                      
                        <th>
                            <button className="btn btn-ghost btn-xs">Contact</button>
                        </th>
                    </tr>
                    {/* row 2 */}
                    <tr>
                        
                        <td>
                            <div className="flex items-center space-x-3">
                                <div className="avatar">
                                    <div className="mask mask-squircle w-12 h-12">
                                    <img src={teamimg2} alt="team-img" />
                                    </div>
                                </div>
                                <div>
                                    <div className="font-bold">Brice Swyre</div>
                                    <div className="text-sm opacity-50">China</div>
                                </div>
                            </div>
                        </td>
                        <td>
                            Carroll Group
                            <br />
                            <span className="badge badge-ghost badge-sm">Tax Accountant</span>
                        </td>
                       
                        <th>
                            <button className="btn btn-ghost btn-xs">Contact</button>
                        </th>
                    </tr>
                    {/* row 3 */}
                    <tr>
                       
                        <td>
                            <div className="flex items-center space-x-3">
                                <div className="avatar">
                                    <div className="mask mask-squircle w-12 h-12">
                                    <img src={teamimg3} alt="team-img" />
                                    </div>
                                </div>
                                <div>
                                    <div className="font-bold">Marjy Ferencz</div>
                                    <div className="text-sm opacity-50">Russia</div>
                                </div>
                            </div>
                        </td>
                        <td>
                            Rowe-Schoen
                            <br />
                            <span className="badge badge-ghost badge-sm">Office Assistant I</span>
                        </td>
                        <th>
                            <button className="btn btn-ghost btn-xs">Contact</button>
                        </th>
                    </tr>
                    
                </tbody>
             

            </table>
        </div>
    );
};

export default OurTeam;